import { partial } from "lodash";
import { PropsWithChildren, ReactElement } from "react";
import { SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu } from "src/components/ui/sidebar";
import { Question, QuestionStats, SurveyStatus } from "src/redux/survey/survey.types";
import ResultsSidebarQuestion from "./results-sidebar-question";

type SurveyResultsSidebarQuestionsProps =
  | { variant: "skeleton" }
  | {
    variant: "data"
    readonly activeQuestion: string;
    readonly questions: Question[];
    readonly questionStats: QuestionStats[];
    readonly handleClick: (index: string) => void;
    readonly showSummaries: boolean;
    readonly surveyStatus: SurveyStatus;
    readonly hideAnswerLetterPrefix?: boolean;
  };

const Layout = ({ children }: PropsWithChildren): ReactElement => {
  return (
    <SidebarGroup className="px-0 pt-0">
      <SidebarGroupLabel
        asChild
        className="group/label px-0 h-12 text-base text-sidebar-foreground pt-3 pb-1 mx-6 border-t rounded-none"
      >
        <span>
          Questions
        </span>
      </SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu className="gap-1">
          {children}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

const SurveyResultsSidebarQuestionList = (props: SurveyResultsSidebarQuestionsProps): ReactElement => {
  const { variant } = props;

  if (variant === "skeleton") {
    return (
      <Layout>
        <ResultsSidebarQuestion variant="skeleton-summary" />
        <ResultsSidebarQuestion variant="skeleton" />
        <ResultsSidebarQuestion variant="skeleton" />
        <ResultsSidebarQuestion variant="skeleton" />
      </Layout>
    );
  }

  const { activeQuestion, questions, questionStats, handleClick, showSummaries, surveyStatus, hideAnswerLetterPrefix } = props;

  return (
    <Layout>
      {showSummaries && (
        <ResultsSidebarQuestion
          variant="summary"
          isActive={activeQuestion === "summary"}
          handleClick={partial(handleClick, 'summary')}
        />
      )}
      {questions.map((question, index) => (
        <ResultsSidebarQuestion
          variant="question"
          key={"question-item-" + index}
          isActive={activeQuestion === String(index + 1)}
          index={index}
          handleClick={partial(handleClick, String(index))}
          question={question}
          questionStats={questionStats[index]}
          surveyStatus={surveyStatus}
          hideAnswerLetterPrefix={hideAnswerLetterPrefix}
        />
      ))}
    </Layout>
  );
};

export default SurveyResultsSidebarQuestionList;
